import { Links, Meta } from "@remix-run/react";

import { ErrorBoundaryComponent } from "~/components/error-boundary/component";

export function RootErrorBoundary() {
  return (
    <html lang="en" className="bg-white">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="icon" href="/static/favicon.ico" />
        <Meta />
        <Links />
      </head>
      <body className="h-dvh " data-theme="cavaco">
        <ErrorBoundaryComponent />
      </body>
    </html>
  );
}

export { ErrorBoundaryComponent } from "./component";
